var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJobSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "job-success-a",
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,16.875A7.875,7.875,0,1,1,16.875,9,7.884,7.884,0,0,1,9,16.875Z",
    fill: "#00ac3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "job-success-a",
    d: "M7.5,11.017l-2.6-2.6-.794.8,3.4,3.4,6.4-6.4-.794-.8Z",
    fill: "#00ac3e"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/job-success.b17fe53212538fb9070f694423341921.svg";